import React from "react";

import { accountContent, sectionHeader, sectionHeaderTitle, sectionHeaderDescription } from "./newsletter.module.scss";

import NewsletterForm from "../../auth/forms/newsletter-form";

export default function Newsletter() {
    return (
        <div className={accountContent}>
            <div className={sectionHeader}>
                <div>
                    <h1 className={sectionHeaderTitle}>Newsletter</h1>
                    <p className={sectionHeaderDescription}>
                        Bądź na bieżąco z nowymi stylizacjami i inspiracjami.
                    </p>
                </div>
            </div>
            <NewsletterForm />
        </div>
    );
}
